import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexRow)<{
    height: number;
}>`
    justify-content: space-between;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: ${(props) => props.height}px;
    padding: 0 24px 0 16px;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    border-color: ${colorsPalettes.carbon[50]};
    background-color: ${colorsPalettes.carbon[0]};
    cursor: pointer;
    transition: all ease-in 0.3s;

    &:hover {
        border-color: ${colorsPalettes.carbon[100]};
        box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    }
`;

export const CardSectionLayout = styled(FlexRow)`
    white-space: nowrap;
    overflow-x: hidden;
`;

export const FiltersSectionLayout = styled(CardSectionLayout)`
    position: absolute;
    right: 24px;
    bottom: 0;
    top: 0;
    padding-left: 165px;
    background-image: linear-gradient(90deg, transparent, ${colorsPalettes.carbon[0]} 30%);
`;

export const Details = styled(FlexColumn)`
    justify-content: center;
    margin: 2px 3px 0;
    overflow-x: hidden;
`;

export const AssetsList = styled.div<{ color: string }>`
    ${({ color = colorsPalettes.carbon[300] }) => setFontVariant("body2", color)};
`;

export const AssetListItem = styled.p`
    display: inline-block;
    margin: 0 10px 0 0;
`;

export const AssetDetails = styled(FlexRow)`
    margin: 2px 0;
`;

export const SubSectionLabel = styled.p`
    margin: auto 0;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const SectionLabel = styled.p`
    margin: auto 0 auto 5px;
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;

export const LastVisitLabel = styled.p`
    margin: auto;
    ${setFontVariant("body2", colorsPalettes.carbon[200])};
`;

export const FiltersWrapper = styled(FlexRow)`
    margin: auto;
`;

export const FilterContainer = styled(FlexRow)`
    margin: auto 0 auto 16px;

    & > * {
        margin: auto;
    }
`;

export const FilterText = styled.p`
    margin: 2px 0 0 4px;
    ${setFontVariant("body2", colorsPalettes.carbon[250])};
`;

export const DiverseIconWrapper = styled.div`
    margin: auto 16px auto 0;
`;
